module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-btn-fill-f80cdbe9.svg";